import * as Sentry from "@sentry/browser";

const sentryErrorHandler = (error, resource, type, responseBody) => {
  let sentryError;
  if (error instanceof Error) {
    sentryError = error;
  } else if (typeof error === "string") {
    sentryError = new Error(error);
  } else {
    sentryError = new Error(`${type} failed for ${resource}.`, { cause: error });
    if (error?.status != null) sentryError.status = error.status;
  }

  if (error?.url) sentryError.url = error.url;

  sentryError.name =
    error?.status != null
      ? `${resource} Request Failed - [${error.status}]`
      : type !== "not-specified"
        ? `${resource} [${type}] Request Failed`
        : `${resource} Request Failed`;

  sentryError.message = error?.message ? error.message : null;
  Sentry.setContext("request", {
    status: sentryError.status ?? null,
    response_body:
      responseBody != null ? responseBody : sentryError.hasOwnProperty("cause") ? sentryError.cause.parsedBody : null,
  });

  Sentry.setTags({ resource: resource, type: type });

  return sentryError;
};

export const throwSentryError = (error, resource = "Unknown Resource", type = "not-specified", responseBody = "") => {
  // Actually throws an error
  throw sentryErrorHandler(error, resource, type, responseBody);
};

export const sendSentryException = (
  error,
  resource = "Unknown Resource",
  type = "not-specified",
  responseBody = ""
) => {
  // Only sends an exception to Sentry, no error is thrown or exception raised
  let sentryError = sentryErrorHandler(error, resource, type, responseBody);
  Sentry.captureException(sentryError);
};
